import React from 'react'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  copilotInsightCardRoot: {
    backgroundColor: 'var(--copilot-bg-color)',
    borderRadius: 16,
    padding: 16
  }
}))

const BaseCopilotInsightWidget = ({ className = '', children }) => {
  const classes = useStyles()
  return <div className={[classes.copilotInsightCardRoot, className].join(' ')}>{children}</div>
}

export default BaseCopilotInsightWidget
